import { render, staticRenderFns } from "./OrderItemPreview.vue?vue&type=template&id=3c28dabf&scoped=true&"
import script from "./OrderItemPreview.vue?vue&type=script&lang=ts&"
export * from "./OrderItemPreview.vue?vue&type=script&lang=ts&"
import style0 from "./OrderItemPreview.vue?vue&type=style&index=0&id=3c28dabf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c28dabf",
  null
  
)

export default component.exports